export default __webpack_public_path__ + "static/media/pause_btn@3x.ec58e688.png";